<script lang="ts">
  import {
    getStorage,
    ref,
    uploadBytes,
    getDownloadURL,
    deleteObject,
  } from "firebase/storage";

  import lightGallery from "lightgallery";
  // Plugins
  import lgThumbnail from "lightgallery/plugins/thumbnail";
  import lgZoom from "lightgallery/plugins/zoom";

  // Create a root reference
  const storage = getStorage();

  let gallery;

  export let noteId;
  export let files;

  import { createEventDispatcher, onMount } from "svelte";

  const dispatch = createEventDispatcher();

  function addFile(newFile) {
    const newFiles = [newFile, ...(files || [])];
    files = newFiles;

    dispatch("setFiles", {
      id: noteId,
      files: newFiles,
    });
  }

  function removeFile(file) {
    const newFiles = files.filter((f) => f !== file);
    files = newFiles;

    dispatch("setFiles", {
      id: noteId,
      files: newFiles,
    });
  }

  let uploadedFiles;

  function submitUpload(event) {
    event.preventDefault();

    // Hack because uploadedFiles is empty when the form is submitted
    setTimeout(() => {
      const file = uploadedFiles[0];
      if (!file) {
        return;
      }

      // FIXME: Prefix filename with note ID?
      const storageRef = ref(storage, `${noteId}/${file.name}`);

      // 'file' comes from the Blob or File API
      uploadBytes(storageRef, file).then((snapshot) => {
        console.log("file uploaded", snapshot);
        getDownloadURL(storageRef).then((downloadURL) => {
          addFile({
            name: file.name,
            url: downloadURL,
          });
        });
      });
    }, 100);
  }

  function imageClick(event, file, index) {
    if (event.metaKey || event.ctrlKey) {
      event.preventDefault();
      event.stopPropagation();

      // Create a reference to the file to delete
      const storageRef = ref(storage, `${noteId}/${file.name}`);

      // Delete the file
      deleteObject(storageRef)
        .then(() => {
          // File deleted successfully
          removeFile(file);
        })
        .catch((error) => {
          // Uh-oh, an error occurred!
          console.error("could not delete file");
        });

      return false;
    }
  }

  function submitForm(e) {
    e.currentTarget.parentElement.submit();
  }

  onMount(() => {
    if (gallery) {
      lightGallery(gallery, {
        plugins: [lgZoom, lgThumbnail],
        speed: 500,
      });
    }
  });
</script>

<div class="files">
  <div class="files-list">
    {#if files}
      <div bind:this={gallery}>
        {#each files as file, index}
          <a href={file.url}>
            <img
              on:click={(event) => imageClick(event, file, index)}
              loading="lazy"
              class="thumbnail"
              src={file.url}
              title={file.name}
              alt={file.name}
            />
          </a>
        {/each}
      </div>
    {/if}
  </div>
  <form>
    <input
      type="file"
      id={`upload-${noteId}`}
      on:change={submitUpload}
      bind:files={uploadedFiles}
      hidden
    />
    <label for={`upload-${noteId}`}><i class="las la-file-upload" /></label>
  </form>
</div>

<style>
  .files {
    position: relative;
    min-height: 40px;
  }

  .files-list {
    white-space: nowrap;
    display: flex;
    flex-wrap: nowrap;
    overflow: auto;
    padding: 0 40px 0 12px;
  }

  img.thumbnail {
    height: 72px;
    margin-right: 12px;
    border-radius: 4px;
  }

  img.lightbox-image {
    width: 90vw;
  }

  :global(.svelte-lightbox-header) {
    position: fixed;
    top: 0;
    width: 90vw !important;
  }

  form {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: flex-end;
    width: 60px;
    background-color: #25282a;
    height: 100%;
    align-items: center;
    background: linear-gradient(
      270deg,
      rgb(37, 40, 42) 0%,
      rgba(37, 40, 42, 0.1) 100%
    );
  }

  label {
    font-size: 24px;
    border-radius: 0.3rem;
    cursor: pointer;
  }
</style>
